import { createAction } from "@reduxjs/toolkit";

export const unbookItemsAction = createAction("models/items/use/unbook");
export const getMyRequestsAction = createAction("auth/requests/get");
